export default __webpack_public_path__ + "static/media/globalConfigIcon.4ed29517.svg";